// extracted by mini-css-extract-plugin
export default {"badgeContainer":"UserBadgesContainer-badgeContainer-9bc525a2112493532e75e55e2e0ef5ab","badge":"UserBadgesContainer-badge-86c7811a2e2f64656573e2798641d0a3"};